import React from "react";
import LegalPage from "./LegalPage";
import { BRAND } from "../lib/site";

export default function HipaaPage() {
  return (
    <LegalPage title="HIPAA Compliance" kicker="Notice of Privacy Practices" testid="page-hipaa">
      <p className="italic text-white/70">
        This notice describes how medical information about you may be used and disclosed,
        and how you can gain access to this information. Please review it carefully.
      </p>

      <h2 className="font-heading text-3xl text-white">1. Our Commitment to Your Privacy</h2>
      <p>
        {BRAND.name} is fully committed to compliance with the Health
        Insurance Portability and Accountability Act of 1996 ("HIPAA")
        and its implementing regulations. We are required by law to
        maintain the privacy of your Protected Health Information ("PHI")
        and to provide you with this Notice of our legal duties and
        privacy practices.
      </p>

      <h2 className="font-heading text-3xl text-white">2. Uses &amp; Disclosures of PHI</h2>
      <p>
        We may use and disclose your PHI for treatment, payment and
        healthcare operations, including coordination of surgical and
        recovery care, billing, and quality assessment. Any other use
        requires your written authorisation, which you may revoke in
        writing at any time.
      </p>

      <h2 className="font-heading text-3xl text-white">3. Your Rights</h2>
      <p>You have the right to:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Inspect and obtain copies of your medical and billing records.</li>
        <li>Request amendments to your medical records.</li>
        <li>Request an accounting of certain disclosures of your PHI.</li>
        <li>Request restrictions on certain uses and disclosures.</li>
        <li>Request confidential communications by alternative means or locations.</li>
        <li>Receive a paper copy of this Notice upon request.</li>
        <li>Be notified in the event of a breach of unsecured PHI.</li>
      </ul>

      <h2 className="font-heading text-3xl text-white">4. Safeguards</h2>
      <p>
        We use administrative, physical and technical safeguards to
        protect your PHI, including encrypted data systems, secure
        workstations, locked file storage, and staff training in privacy
        practices.
      </p>

      <h2 className="font-heading text-3xl text-white">5. Marketing &amp; Sale of Information</h2>
      <p>
        We will never sell your PHI. Marketing communications involving
        PHI will only be sent with your written authorisation.
      </p>

      <h2 className="font-heading text-3xl text-white">6. Patient Imagery</h2>
      <p>
        Before-and-after photography is taken solely with your written,
        revocable consent. You may decline photography or limit how
        images are used (internal records, in-office display, marketing).
      </p>

      <h2 className="font-heading text-3xl text-white">7. Complaints</h2>
      <p>
        If you believe your privacy rights have been violated, you may
        file a complaint with our Privacy Officer at{" "}
        <a className="text-gold" href={`mailto:${BRAND.email}`}>{BRAND.email}</a> or with
        the U.S. Department of Health and Human Services, Office for
        Civil Rights. You will not be retaliated against for filing a
        complaint.
      </p>

      <h2 className="font-heading text-3xl text-white">8. Effective Date &amp; Changes</h2>
      <p>
        This Notice is effective as of the date listed above. We reserve
        the right to revise this Notice and apply changes to PHI we
        already maintain. Revised notices will be available at our office
        and posted on this page.
      </p>
    </LegalPage>
  );
}
